<template>
  <div class="banner">
    <div class="banner_box">
      <el-carousel trigger="click" height="380px" :autoplay="false" arrow="never">
        <el-carousel-item>
          <img src="./image/banner_04.jpg" alt="" @click="goBannerDetail">
        </el-carousel-item>
      </el-carousel>
    </div>
     <div class="entryPointBox" :style="{ width: boxCardW + 'px' ,height: boxCardH + 'px',top:twoImgTop1+'px'}" @click="goSignUp"><img src="./image/entryPoint.jpg" alt=""></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      boxCardW:320,
      boxCardH:150,
      twoImgTop1:150
    };
  },
  created(){
    //获取屏幕可视区域的宽高
    if(document.body.clientWidth<1400){
      this.boxCardW=211;
      this.boxCardH=105;
    }
  },
  methods:{
    goBannerDetail(){
      window.open("http://cce.scu.edu.cn/mana/view/home/news.do?id=3985");
    },
    goSignUp(){
      window.open("http://cce.scu.edu.cn/mana/view/home/exam/preRegCJ.jsp");
    },
  }
};
</script> 

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 380px;
  background-image: url("./image/bg.jpg");
  // background-color: #CD402E;
  .banner_box {
    width: 1200px;
    height: 100%;
    background-color: #fff;
    margin: 0 auto;
    ::v-deep .el-carousel__indicator.is-active button{
       opacity: 0 !important;
    }
  }
}
.el-carousel__item img{
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.entryPointBox{
  position: fixed;
  z-index: 9999;
  // top: 150px;
  right: 0;
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
  }
}

</style>
